export default "__VITE_ASSET__CFSCJOEt__"